export const InputLimitAndEmptyValueHandling = (InputLimit, e) => {
    const eElement = InputLimit.find(elem => elem.InputName === e.target.name)
    if(e.target.value>eElement.LimitMax&&eElement.LimitMax!=null&&e.target.value!==""){
        return(eElement.LimitMax);
    }else if(e.target.value<eElement.LimitMin&&eElement.LimitMin!=null&&e.target.value!==""){
        return(eElement.LimitMin);
    }else if(e.target.value===""){
        return(eElement.default);
    }else {
        return (parseFloat(e.target.value))
    }
}